import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import * as FaLightIcons from '@fortawesome/pro-light-svg-icons';


export default /*#__PURE__*/_defineComponent({
  props: {
  icon: String,
},
  setup(__props) {

library.add(...Object.values(Object.values(FaLightIcons)[0]));



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FontAwesomeIcon), { icon: __props.icon }, null, 8, ["icon"]))
}
}

})